export default __webpack_public_path__ + "static/media/sinexito.6642237c.png";